import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bg_Img from "./assets/images/flight-background.webp";
import callgirl_img from "./assets/images/flight-callinggirl.webp";
import { Dropdown, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import emailjs from "@emailjs/browser";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../src/style/home.css";

const schema = yup.object().shape({
  fullName: yup.string().min(3, "Too short").required("Full Name is required"),
  phone: yup
    .string()
    .matches(
      /^[0-9]{10}$/,
      "Phone number must be exactly 10 digits and contain only numbers"
    )
    .required("Phone number is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  dateOfJourney: yup
    .date()
    .typeError("Invalid date format")
    .min(new Date(), "Date must be in the future")
    .required("Date is required"),
  source: yup.string().required("Source is required"),
  destination: yup.string().required("Destination is required"),
  trip: yup.string().required("Trip type is required"),
  adults: yup
    .number()
    .typeError("Adults must be a valid number")
    .integer("Adults must be a whole number")
    .min(1, "At least one adult required")
    .required("Number of adults is required"),
  children: yup
    .number()
    .typeError("Children must be a valid number")
    .integer("Children must be a whole number")
    .min(0, "Children cannot be negative")
    .required("Number of children is required"),
});

const GOOGLE_SHEET_URL =
  "https://script.google.com/macros/s/AKfycby0NiG3mcmDKmltPQBkzprlDruF7wxNbhGdaSc97ER9nG1z7Mc0PRsyh_vyePtTV9LH/exec";

const FlightSearch = ({ onClose }) => {
  const [tripType, setTripType] = useState("Round-Trip");
  const [travelers, setTravelers] = useState({
    adults: "",
    children: "",
  });
  const [cabinClass, setCabinClass] = useState("Economy");
  const [departDate, setDepartDate] = useState(null);
  const [returnDate, setReturnDate] = useState(null);
  const [showTravelerDropdown, setShowTravelerDropdown] = useState(false);
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const handleIncrement = (type) => {
    setTravelers((prev) => ({ ...prev, [type]: prev[type] + 1 }));
  };

  const handleDecrement = (type) => {
    if (travelers[type] > 0) {
      setTravelers((prev) => ({ ...prev, [type]: prev[type] - 1 }));
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { adults: "", children: "" },
  });

  const handleModalClose = () => {
    console.log("Closing Modal...");
    onClose(); // Close modal
  };

  // const onSubmit = async (data) => {
  //   try {
  //     console.log("Sending Data:", data);
  //     const response = await fetch(GOOGLE_SHEET_URL, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //       body: new URLSearchParams(data).toString(),
  //     });
  //     const result = await response.json();
  //     console.log("Response:", result);

  //     if (result.result === "success") {
  //       alert("Form submitted successfully!");
  //       handleModalClose();
  //     } else {
  //       alert("Error: " + result.error);
  //     }
  //   } catch (error) {
  //     console.error("Error submitting form:", error);
  //     alert("Failed to submit form.");
  //   }
  // };

  const onSubmit = async (data) => {
    try {
      console.log("Sending Data:", data);

      // Sending data to Google Sheets
      const response = await fetch(GOOGLE_SHEET_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data).toString(),
      });

      const result = await response.json();
      console.log("Google Sheets Response:", result);

      // If Google Sheets submission is successful, send email
      if (result.result === "success") {
        const emailResponse = await emailjs.send(
          "service_6cvgbal", // Replace with your EmailJS Service ID
          "template_srnyza7", // Replace with your EmailJS Template ID
          {
            fullName: data.fullName,
            phone: data.phone,
            email: data.email,
            dateOfJourney: data.dateOfJourney,
            source: data.source,
            destination: data.destination,
            trip: data.trip,
            adults: data.adults,
            children: data.children,
          },
          "_xyrSV8unWRyjvI89" // Replace with your EmailJS Public Key
        );

        console.log("Email Sent:", emailResponse);
        alert("Form submitted successfully and email sent!");
        handleModalClose();
      } else {
        alert("Error submitting form to Google Sheets: " + result.error);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to submit form or send email.");
    }
  };

  return (
    <div className="bg-primary ">
      <div
        className="d-flex align-items-center justify-content-center text-white position-relative"
        style={{
          minHeight: "90vh",
          backgroundImage: `url(${bg_Img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundBlendMode: "darken",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            {/* Search Form */}
            <div className="col-lg-6 col-md-8 col-sm-10 p-4 text-white rounded shadow-lg form">
              <h4 className="text-center fw-bold">Search Flights</h4>

              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="mb-1">
                  <Form.Control
                    type="text"
                    className="form-control"
                    placeholder="Full Name"
                    {...register("fullName")}
                  />
                  <small className="text-danger">
                    {errors.fullName?.message}
                  </small>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Form.Control
                    type="text"
                    className="form-control"
                    placeholder="Phone Number"
                    {...register("phone")}
                  />
                  <small className="text-danger">{errors.phone?.message}</small>
                </Form.Group>
                {/* </Form> */}

                <div className="d-flex flex-wrap mb-4 justify-content-between">
                  <div className="row">
                    <div className="col-md-6">
                      <select
                        className="form-control mt-2"
                        {...register("trip")}
                      >
                        <option value="">Select Trip</option>
                        <option value="One Way">One Way</option>
                        <option value="Round Trip">Round Trip</option>
                      </select>
                      <small className="text-danger">
                        {errors.trip?.message}
                      </small>
                    </div>

                    <div className="col-md-3">
                      <input
                        type="number"
                        className="form-control mt-2"
                        placeholder="Adults"
                        {...register("adults")}
                        // min="1"
                        value={travelers.adults}
                        onChange={(e) =>
                          setTravelers({
                            ...travelers,
                            adults: e.target.value ? +e.target.value : "",
                          })
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <input
                        type="number"
                        className="form-control mt-2"
                        placeholder="Children"
                        {...register("children")}
                        // min="0"
                        value={travelers.children}
                        onChange={(e) =>
                          setTravelers({
                            ...travelers,
                            children: e.target.value ? +e.target.value : "",
                          })
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* <Form> */}
                <Form.Group className="mb-4">
                  <Form.Select {...register("source")}>
                    <option value="">Select Source</option>
                    <option value="New York">New York</option>
                    <option value="Los Angeles">Los Angeles</option>
                    <option value="Chicago">Chicago</option>
                    <option value="Houston">Houston</option>
                    <option value="San Francisco">San Francisco</option>
                  </Form.Select>
                  <small className="text-danger">
                    {errors.source?.message}
                  </small>
                </Form.Group>

                <Form.Group className="mb-2">
                  <Form.Select {...register("destination")}>
                    <option value="">Select Destination</option>
                    <option value="Miami">Miami</option>
                    <option value="Seattle">Seattle</option>
                    <option value="Dallas">Dallas</option>
                    <option value="Atlanta">Atlanta</option>
                    <option value="Boston">Boston</option>
                  </Form.Select>
                  <small className="text-danger">
                    {errors.destination?.message}
                  </small>
                </Form.Group>
                <div className="d-flex flex-wrap gap-2">
                  {/* Depart Date Picker */}
                  {/* <Form.Group className="mb-2">
                  <DatePicker
                    selected={departDate}
                    onChange={(date) => setDepartDate(date)}
                    placeholderText="From date"
                    // {...register("dateOfJourney")}
                    customInput={
                      <Form.Control
                        placeholder="From date"
                        {...(departDate
                          ? { value: departDate.toLocaleDateString() }
                          : {})}
                      />
                    }
                  />
                </Form.Group> */}

                  {/* Return Date Picker */}
                  {/* <Form.Group className="mb-2">
                  <DatePicker
                    selected={returnDate}
                    onChange={(date) => setReturnDate(date)}
                    placeholderText="To date"
                    // {...register("dateOfJourney")}
                    customInput={
                      <Form.Control
                        placeholder="To date"
                        {...(returnDate
                          ? { value: returnDate.toLocaleDateString() }
                          : {})}
                      />
                    }
                    disabled={tripType === "One-Way"}
                  />
                </Form.Group> */}

                  <Form.Group className="mb-2">
                    <DatePicker
                      selected={departDate}
                      onChange={(date) => setDepartDate(date)}
                      placeholderText="From date"
                      customInput={
                        <Form.Control
                          value={
                            departDate ? departDate.toLocaleDateString() : ""
                          }
                          placeholder="From date"
                          onFocus={(e) => (e.target.placeholder = "")}
                          onBlur={(e) => (e.target.placeholder = "From date")}
                          readOnly
                        />
                      }
                    />
                  </Form.Group>

                  {/* Return Date Picker */}
                  <Form.Group className="mb-2">
                    <DatePicker
                      selected={returnDate}
                      onChange={(date) => setReturnDate(date)}
                      placeholderText="To date"
                      customInput={
                        <Form.Control
                          value={
                            returnDate ? returnDate.toLocaleDateString() : ""
                          }
                          placeholder="To date"
                          onFocus={(e) => (e.target.placeholder = "")}
                          onBlur={(e) => (e.target.placeholder = "To date")}
                          readOnly
                        />
                      }
                      disabled={tripType === "One-Way"}
                    />
                  </Form.Group>
                </div>
                <Button type="Submit" className="mt-3 w-100 bg-danger border-0">
                  Search Flights
                </Button>
              </Form>
            </div>

            {/* Right Side - Information Section */}
            <div className="col-lg-6 text-white text-center mt-4 mt-lg-0">
              <h2>Effortless Booking & Big Saves:</h2>
              <h2>
                Choose from <span className="text-warning">400+ Airlines</span>
              </h2>
              <p>Consult a travel specialist for discounts.</p>
              <p>Get the latest available deals to your inbox.</p>
              <p>Customize an ideal flight deal and enjoy travel.</p>

              <h4 className="mt-3">
                Dial up one of 120 proficient travel specialists
              </h4>
              <h3 className="text-white d-flex align-items-center justify-content-center">
                1-877-254-8655
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Text */}
      <div
        className="text-center text-white my-2 py-2"
        style={{ backgroundColor: "#1666af;" }}
      >
        <h5>
          Dial us and get <strong className="text-warning">EXTRA $30</strong> on
          every flight booking ticket
        </h5>
      </div>
    </div>
  );
};

export default FlightSearch;
